export const OnboardStatus = {
  NONE: 0,
  IMPORTED: 1,
  INVITED: 2,
  ONBOARD_PENDING: 3,
  ONBOARDED: 4,
  SUSPENDED: 5
};
